import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";
import { sharePoint } from "../services/soar";

function FolderChangeModal({
  show,
  item,
  stateId,
  currentFolder,
  availableFolders,
  handleClose,
}) {
  const [newFolder, setNewFolder] = useState("");

  const handleSave = async () => {
    if (newFolder === "") {
      toast.error("Please select a folder");
    } else {
      let toastId = toast.info("Changing folder...");
      const body = {
        Command: "update",
        LibraryId: stateId,
        Field: "FolderType",
        Value: newFolder,
        FileId: item.id,
      };

      const resp = await sharePoint(body);
      if (resp) {
        toast.update(toastId, {
          render: "Folder changed successfully",
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
          closeOnClick: true,
        });
        handleClose();
      } else {
        toast.update(toastId, {
          render: "Error changing folder",
          type: toast.TYPE.ERROR,
          autoClose: 10000,
        });
      }
    }
    setNewFolder("");
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Change Folder</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-safy2-4">
          <div className="h6 mb-0">Current Folder</div>
          <div className="mb-4">{currentFolder}</div>
          <FloatingInput
            type="select"
            label="Select New Folder"
            options={availableFolders.map((folder, index) => {
              return {
                key: `availablefolder-${index}`,
                _id: folder,
                name: folder,
              };
            })}
            value={newFolder}
            onChange={(e) => setNewFolder(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer className="bg-safy2-4">
          <div className="btn btn-sm btn-danger" onClick={handleClose}>
            Cancel
          </div>
          <div className="btn btn-sm btn-success" onClick={handleSave}>
            Save
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FolderChangeModal;
